import React from 'react';
import TimesheetDateTimeButton from './TimesheetDateTimeButton';
import PhaseCodeManager from './PhaseCodeManager';
import TotalTimeIndicator from './TotalTimeIndicator';

export default class TimesheetTimeAndPhaseCodes extends React.Component {
    render() {
        const { loading, timesheet } = this.props;

        if (loading || !timesheet) {
            return null;
        }

        return (
            <div className="d-flex mb-2 phase-grid-row">
                <TimesheetDateTimeButton {...this.props} />

                <PhaseCodeManager {...this.props} />

                <TotalTimeIndicator {...this.props} />
            </div>
        );
    }
}
